
import AssetPage from "../components/Assests/AssetPage";
import CreateCategory from "../components/Category/CreateCategory";
import ContactCreationPage from "../components/Contact/ContactCreation";
import AgentCreationPage from "../components/CreateAgent/AgentCreationPage";
import GroupCreationPage from "../components/Group/Group";
import OrganizationsCreation from "../components/Organizations/OrganizationsCreation";
import OrganiztionLogin from "../components/Organizations/OrganiztionLogin";
import RoleCreation from "../components/Roles/CreateNewRoles";
import TicketTypeCreationPage from "../components/SystemManagement/TicketTypeCreationPage";
import TicketCreationPage from "../components/tickets/CreateNewTicket";
import TicketDetail from "../components/tickets/TicketDetails";
import TicketUpdatePage from "../components/tickets/UpdateTicket";
import MarkdownComponents from "../utils/MarkdownComponents";
import { agentroleapiendpoints, assetApiEndpoints, changeContactStatusApiEndpoints, CreateAgentapiendpoints, createContactApiEndpoints, createOrUpdateTicketApi, createPriorityApiEndpoints, createRoleapiendpoints, createTicketApiEndpoint, createWorkingTimePlanApiEndpoints, dashboardapiendpoints, dashboardV3apiendpoints, deleteCategoryApiEndpoints, deletePriorityApiEndpoints, deleteRolesapiendpoints, deleteWorkingTimePlanApiEndpoints, getAgentByIdApiendpoints, getAgentByTokenapiendpoints, getAllAgentapiendpoints, getCategoryByIdApiEndpoints, getCategoryListApiEndpoints, getContactByIdApiEndpoints, getContactsApiEndpoints, getPriorityByIdApiEndpoints, getPriorityListApiEndpoints, getRoleByIdapiendpoints, getRoleListapiendpoints, getTicketLogAttachmentsApiEndpoints, getTicketStatusListApiEndpoints, getTicketTimelineApiEndpoint, getWorkingTimePlanApiEndpoints, getWorkingTimePlanByIdApiEndpoints, groupallapiendpoints, groupByIdapiendpoints, groupCreationapiendpoints, groupSoftDeleteapiendpoints, loginApiEndPoints, SoftDeleteapiendpoints, SubscriptionAapiendpoints, ticketNotificationsapiendpoints, TicketTypByIdapiendpoints, TicketTypeapiendpoints, updateAgentapiendpoints, updateCategoryApiEndpoints, updateContactByIdApiEndpoints, updateGroupByIDapiendpoints, updatePriorityApiEndpoints, updateRoleapiendpoints, updateTicketApiEndpoints, updateTicketPriorityApiEndpoint, updateWorkingTimePlanApiEndpoints, userGroupapiendpoints } from "./apiEndpoints";
import { agentApiMarkdown, agentByTokenMarkdown, agentCreateMarkdown, agentGetByIdMarkdown, agentListMarkdown, agentStatusChangeMarkdown, agentUpdateMarkdown, AssetsMarkdowns, categoryByIdMarkdown, changeContactStatusMarkdown, createContactMarkdown, createPriorityMarkdown, createTicketMarkdown, createWorkingTimePlanMarkdown, dashboardUserGroupsMarkdown, dashboardV3Markdown, deleteCategoryMarkdown, deletePriorityMarkdown, deleteWorkingTimePlanMarkdown, getCategoryListmarkdown, getContactByIdMarkdown, getContactsMarkdown, getPriorityByIdMarkdown, getRoleByIdMarkdown, getStatedmarkdown, getTicketLogAttachmentsMarkdown, getTicketStatusListMarkdown, getTicketTimelineMarkdown, getWorkingTimePlanByIdMarkdown, getWorkingTimePlanMarkdown, groupCreateMarkdown, groupGetByIdMarkdown, groupListMarkdown, groupSoftDeleteMarkdown, groupUpdateByIDMarkdown, LoginOrganisation, markdown, organisationBySubdomain, priorityListMarkdown, roleBulkSoftDeleteMarkdown, roleCreateMarkdown, roleGetByIdMarkdown, roleListMarkdown, roleUpdateMarkdown, subscriptionListMarkdown, ticketMarkdowns, ticketNotificationsMarkdown, ticketTypeGetByIdMarkdown, ticketTypeListMarkdown, ticketTypeUpdateMarkdown, updateCategoryMarkdown, updateContactByIdMarkdown, updatePriorityMarkdown, updateTicketMarkdown, updateTicketPriorityMarkdown, updateWorkingTimePlanMarkdown } from "./markDownData";
import { AuthContext } from "../utils/AuthContext";

export const documentationData = (myOrgName, token = "", tenantCode = "", baseUrl) => [
  {
    title: "Get started",
    id: "get-started-section",
    items: [
      {
        id: "group",
        label: "Get started",
        children: [
          // ....
          {
            id: "Get-started-0",
            label: "Get started",
            content: {
              title: "organisation BySubdomain ",
              description: <MarkdownComponents markdown={getStatedmarkdown} />,
              apiendpoints:[]
            },
          },
          

          {
            id: "organisation-by-subdomain",
            label: "organisation By Subdomain",
            content: {
              title: "organisation BySubdomain ",
              description: <MarkdownComponents markdown={organisationBySubdomain} />,
              apiendpoints: [{
                name: "Secure API Endpoint",
                path: `${baseUrl}/gateway/master/Organisation/by/subdomain?subdomain=${myOrgName}`, // Replace with your actual API endpoint
                methods: ["GET", "POST"],
                description: "Test endpoint with encryption capabilities",
                headers: [
                  { key: 'tenant-code', value: tenantCode, enabled: true },
                  { key: 'Content-Encrypted', value: 'true', enabled: true },
                ],
                parameters: [
                  {
                    name: "secure",
                    description: "Whether to use encryption",
                    type: "boolean",
                    required: false
                  }
                ],
                requestBody: {},
                responses: {
                  success: {
                    status: 200,
                    data: {
                      body: {
                        "tenantcode": "vizionsys"
                      },

                    }
                  },
                  error: {
                    status: 400,
                    data: {
                      error: "Invalid request",
                      message: "Missing required fields"
                    }
                  }
                }
              }]
            },
          },

          {

            id: "authentication-login",
            label: "Authentication Login ",
            content: {
              title: "organisation  Authentication  ",
              description: <MarkdownComponents markdown={LoginOrganisation} />,
              apiendpoints: loginApiEndPoints(token, tenantCode, myOrgName, baseUrl)
            },
          },
          {
            id: "group",
            label: "Agent Creation",
            content: {
              title: "Agent Creation",
              description: <MarkdownComponents markdown={agentApiMarkdown} />,
              apiendpoints: [{
                name: "Secure API Endpoint",
                path: `${baseUrl}/gateway/Agent`, // Replace with your actual API endpoint
                methods: ["GET", "POST"],
                description: "Test endpoint with encryption capabilities",
                headers: [
                  { key: 'tenant-code', value: 'vizionsys', enabled: true },
                  { key: 'Content-Encrypted', value: 'true', enabled: true },
                  {
                    key: 'Authorization', value:
                      `Bearer ${token}`

                    , enabled: true
                  }
                ],
                parameters: [
                  {
                    name: "secure",
                    description: "Whether to use encryption",
                    type: "boolean",
                    required: false
                  }
                ],
                requestBody: {
                  "firstName": "Test ",
                  "lastName": "postman",
                  "userName": "",
                  "agentTypeId": 0,
                  "mobilePhone": "",
                  "email": "",
                  "isAdmin": false,
                  "roleId": 38,
                  "language": "",
                  "licenseKeyId": null,
                  "agentDescription": "postman",
                  "agentAvatarId": 0,
                  "isTwoFactorEnabled": false,
                  "userGroupList": [
                    {
                      "groupId": 1,
                      "isDefault": false
                    },
                    {
                      "groupId": 2,
                      "isDefault": true
                    },
                    {
                      "groupId": 10,
                      "isDefault": false
                    }
                  ],
                  "password": {
                    "passwordHash": "123456"
                  }
                },
                responses: {
                  success: {
                    status: 200,
                    data: {
                      id: 101,
                      title: "Sample Post",
                      body: "This is the content of the post",
                      userId: 1
                    }
                  },
                  error: {
                    status: 400,
                    data: {
                      error: "Invalid request",
                      message: "Missing required fields"
                    }
                  }
                }
              }]
            },
          },

        ],
      },
    ],
  },
  {
    title: "New Ticket",
    id: "new-ticket-section",
    items: [{
      id: "new-ticket-section",
      label: "Ticket Section",
      children: [
        {
          id: "ticket-creation",
          label: "Ticket Creation",
          content: {
            title: "Ticket Creation",
            description: <MarkdownComponents markdown={createTicketMarkdown} />,
            apiendpoints: createTicketApiEndpoint(token, tenantCode, myOrgName, baseUrl)

          },
        },
        {
          id: "ticket-Update",
          label: "Ticket Update",
          content: {
            title: "Ticket Update",
            description: <MarkdownComponents markdown={updateTicketMarkdown} />,
            apiendpoints: updateTicketApiEndpoints(token, tenantCode, myOrgName, baseUrl)

          },
        },

        {
          id: "ticket-log-by-id",
          label: "Ticket Log  By ID",
          content: {
            title: "Ticket Log  By ID",
            description: <MarkdownComponents markdown={getTicketLogAttachmentsMarkdown} />,
            apiendpoints: getTicketLogAttachmentsApiEndpoints(token, tenantCode, myOrgName, baseUrl)

          },
        },

        {
          id: "get-ticket-timeline",
          label: "Get Ticket Timeline",
          content: {
            title: "Get Ticket Timeline",
            description: <MarkdownComponents markdown={getTicketTimelineMarkdown} />,
            apiendpoints: getTicketTimelineApiEndpoint(token, tenantCode, myOrgName, baseUrl)

          },
        },
        // Ticket Drag and drop in Status View


        {
          id: "ticket-drag-and-drop-in-status-view",
          label: "Ticket Drag and drop in Status View",
          content: {
            title: "Ticket Drag and drop in Status View",
            description: <MarkdownComponents markdown={getTicketTimelineMarkdown} />,
            apiendpoints: getTicketTimelineApiEndpoint(token, tenantCode, myOrgName, baseUrl)

          },
        },
        {
          id: "ticket-update-to-priority",
          label: "Ticket update to Priority",
          content: {
            title: "Ticket update to Priority ",
            description: <MarkdownComponents markdown={updateTicketPriorityMarkdown} />,
            apiendpoints: updateTicketPriorityApiEndpoint(token, tenantCode, myOrgName, baseUrl)

          },
        },
        {
          id: "get-all-tickettype",
          label: "Get All TicketType",
          content: {
            title: "Get All TicketType",
            description: <MarkdownComponents markdown={ticketTypeListMarkdown} />,
            apiendpoints: TicketTypeapiendpoints(token, tenantCode, myOrgName, baseUrl)
          },
        },
        {
          id: "get-tickettype-by-id",
          label: "Get TicketType By ID",
          content: {
            title: "Get TicketType  By ID",
            description: <MarkdownComponents markdown={ticketTypeGetByIdMarkdown} />,
            apiendpoints: TicketTypByIdapiendpoints(token, tenantCode, myOrgName, baseUrl)
          },
        },
        {
          id: "update-ticket-type",
          label: "Update Ticket Type",
          content: {
            title: "Update ticketType By ID",
            description: <MarkdownComponents markdown={ticketTypeUpdateMarkdown} />,
            apiendpoints: TicketTypByIdapiendpoints(token, tenantCode, myOrgName, baseUrl)
          },
        },

        {
          id: "ticket-Detail",
          label: "Ticket Detail",
          content: {
            title: "Ticket Detail ",
            description: <TicketDetail />,

            endpoints: [
              {
                "name": "Get Ticket Details",
                "path": `${baseUrl}/gateway/Ticket/{ticketId}`,
                "methods": ["GET"],
                "description": "Retrieves complete details of a specific ticket including status, priority, assigned agent, contact information, and latest updates",
                "headers": {
                  "Content-Type": "application/json",
                  "Authorization": "Bearer <token>",
                  "tenant-code": "vizionsys"
                },
                "parameters": [
                  {
                    "name": "ticketId",
                    "description": "Unique identifier of the ticket",
                    "type": "integer",
                    "required": true,
                    "example": 4394
                  }
                ],
                "responses": {
                  "success": {
                    "status": 200,
                    "data": {
                      "id": 4394,
                      "sourceCode": "SSP",
                      "createdDateTime": "2025-07-07T06:17:40.983584",
                      "isActive": true,
                      "ticketLogs": {
                        "id": 51549,
                        "type": "Update",
                        "title": "sss",
                        "note": "mmm",
                        "description": "sss",
                        "statusId": 3,
                        "ticketTypeId": 51,
                        "priorityId": 1,
                        "dueDateTime": "2025-07-07T09:30:00",
                        "updatedDateTime": "2025-07-07T09:47:04.8169699Z",
                        "isNotePrivate": true,
                        "circulationListTO": "ashwini.thm@vizionsys.com",
                        "ticketStatus": {
                          "id": 3,
                          "name": "InProgress",
                          "displayName": "In Progress"
                        },
                        "priority": {
                          "id": 1,
                          "name": "P1"
                        },
                        "ticketType": {
                          "id": 51,
                          "name": "Service Request"
                        },
                        "group": {
                          "id": 1,
                          "name": "1st Line"
                        },
                        "agent": {
                          "id": 1,
                          "fullName": "Amith Malipatil"
                        },
                        "contacts": {
                          "id": 2,
                          "isVIP": true,
                          "name": "Ashwini",
                          "email": "ashwini.thm@vizionsys.com"
                        },
                        "category": {
                          "id": 2168,
                          "name": "Collaboration"
                        }
                      },
                      "ticketAssetList": [],
                      "ticketTagList": []
                    }
                  },
                  "error": {
                    "status": 404,
                    "data": {
                      "error": "Ticket not found",
                      "message": "No ticket exists with ID 4394"
                    }
                  }
                },
                "securityNote": "Requires authentication. VIP contact information should be protected with additional access controls."
              },

            ]

          },
        },
        {
          id: "priority-list",
          label: "Priority List",
          content: {
            title: "Priority List",
            description: "under development",
          },
        },
        {
          id: "contacts",
          label: "Contacts",
          content: {
            title: "Contacts",
            description: <><ContactCreationPage /></>,
          },
        },
        {
          id: "agent",
          label: "Agent",
          content: {
            title: "Agent",
            description: "under development",
          },
        },
        {
          id: "email-template",
          label: "Email Template",
          content: {
            title: "Email Template",
            description: "under development",
          },
        },
      ]
    }]

    ,
  },
  {
    title: "CMDB",
    id: "cmdb-section",
    items: [
      {
        id: 'cmdb-section',
        label: "CMDB",
        children: [{
          id: "cmdb-create",
          label: "CMDB Create",
          content: {
            title: "CMDB Create",
            description: "under development",
          },
        },
        {
          id: "assests",
          label: "Assests",
          content: {
            title: "Assests",
            description: <AssetPage />,
          },
        },


        ]
      }

    ],
  },
 
  {
    title: "Ticket Management",
    id: "ticket-management-section",
    items: [{
      id: "ticket-management-section",
      label: "Ticket Management",
      children:
        [{
          id: "tickettask",
          label: "Ticket Task",
          content: {
            title: "Ticket Type creation",
            description: <TicketTypeCreationPage />
          },
        },
        {
          id: "ticket-notification",
          label: "Ticket Notification",
          content: {
            title: "Ticket Notification",
            description: "under development",
          },
        },
        {
          id: "systemmanagement",
          label: "System Management",
          content: {
            title: "System Management",
            description: "under development",
          },
        },]
    }
    ],
  },
  {
    title: "Contact Management",
    id: "contact-management-section",
    items: [{
      id: "contact-management-section",
      label: "Contact Management",
      children:
        [
          {
            id: "location",
            label: "Location",
            content: {
              title: "Location",
              description: "under development",
            },
          },
          {
            id: "contactorganisationtype",
            label: "Contact Organisation Type",
            content: {
              title: "Contact Organisation Type",
              description: "under development",
            },
          },


          {
            id: "department",
            label: "Department",
            content: {
              title: "Department",
              description: "under development",
            },
          },
        ],
    }]
  },
  {
    title: "Knowledge Base",
    id: "knowledge-base-section",
    items: [
      {
        id: "knowledge-base-section",
        label: "Knowledge Base",
        children:
          [
            {
              id: "article",
              label: "Article",
              content: {
                title: "Article",
                description: "under development",
              },
            },
            {
              id: "report",
              label: "Report",
              content: {
                title: "Report",
                description: "under development",
              },
            },
          ],
      }]
  },
  {
    title: "System Management",
    id: "system-management-section",
    items: [{
      id: "system-management-section",
      label: "System Management",
      children:
        [
          {
            id: "workflow",
            label: "Workflow",
            content: {
              title: "Workflow",
              description: "under development",
            },
          },
          {
            id: "survey",
            label: "Survey",
            content: {
              title: "Survey",
              description: "under development",
            },
          },
        ],
    }]
  },






  // // ============================================
  // {
  //   title: "Get started",
  //   id: "get-started-section-real",
  //   items: [
  //     {
  //       id: "group",
  //       label: "Get started --",
  //       children: [
  //         {
  //           id: "group00",
  //           label: "Agent Creation",
  //           content: {
  //             title: "Agent Creation",
  //             description: <MarkdownComponents markdown={agentApiMarkdown} />,
  //             apiendpoints: [{
  //               name: "Secure API Endpoint",
  //               path: `${baseUrl}/gateway/Agent`, // Replace with your actual API endpoint
  //               methods: ["GET", "POST"],
  //               description: "Test endpoint with encryption capabilities",
  //               headers: [
  //                 { key: 'tenant-code', value: 'vizionsys', enabled: true },
  //                 { key: 'Content-Encrypted', value: 'true', enabled: true },
  //                 { key: 'Authorization', value: `Bearer iXZlwSLhC355kOrLdsJku4xhrzWpnjglfU7Ehi+JqYq0N4gJsWc9+ATcHIu8VMs6g32yvdde+lSbrRm9b8+cg86Ha7O3wXbqSYTpxyAROXzh72OFcZANPy38hcMaU9aoS1q+kVddylirGWLwMOc4IdfbNDwpQm9qNh8nmx9keIyrc+zS6Oe5jJInhXIDosZca20bBr8kr7n/yoGEfVQoiKUJoxXdITy9iUZyx3YKdcAV7/vtgiTAnjxuYiZUkuqc3FeFLI0R1mxDVnrct0GU3zyO2xtGs3ZtbaIEho6RaeQDuRK4cqAzYFxXPlDKK5dJwFikUBamtnaOjoO6lFbeSFfwkayDlhfAyPY3wxg9yzUD+WsxvStfLTOlOrDvEa/j`, enabled: true }
  //               ],
  //               parameters: [
  //                 {
  //                   name: "secure",
  //                   description: "Whether to use encryption",
  //                   type: "boolean",
  //                   required: false
  //                 }
  //               ],
  //               requestBody: {
  //                 "firstName": "Test ",
  //                 "lastName": "postman",
  //                 "userName": "",
  //                 "agentTypeId": 0,
  //                 "mobilePhone": "",
  //                 "email": "",
  //                 "isAdmin": false,
  //                 "roleId": 38,
  //                 "language": "",
  //                 "licenseKeyId": null,
  //                 "agentDescription": "postman",
  //                 "agentAvatarId": 0,
  //                 "isTwoFactorEnabled": false,
  //                 "userGroupList": [
  //                   {
  //                     "groupId": 1,
  //                     "isDefault": false
  //                   },
  //                   {
  //                     "groupId": 2,
  //                     "isDefault": true
  //                   },
  //                   {
  //                     "groupId": 10,
  //                     "isDefault": false
  //                   }
  //                 ],
  //                 "password": {
  //                   "passwordHash": "123456"
  //                 }
  //               },
  //               responses: {
  //                 success: {
  //                   status: 200,
  //                   data: {
  //                     id: 101,
  //                     title: "Sample Post",
  //                     body: "This is the content of the post",
  //                     userId: 1
  //                   }
  //                 },
  //                 error: {
  //                   status: 400,
  //                   data: {
  //                     error: "Invalid request",
  //                     message: "Missing required fields"
  //                   }
  //                 }
  //               }
  //             }]
  //           },
  //         },
  //         {
  //           id: "organisationBySubdomain",
  //           label: "organisation By Subdomain",
  //           content: {
  //             title: "organisation BySubdomain ",
  //             description: <MarkdownComponents markdown={organisationBySubdomain} />,
  //             apiendpoints: [{
  //               name: "Secure API Endpoint",
  //               path: `${baseUrl}/gateway/master/Organisation/by/subdomain?subdomain=${myOrgName}`, // Replace with your actual API endpoint
  //               methods: ["GET", "POST"],
  //               description: "Test endpoint with encryption capabilities",
  //               headers: [
  //                 { key: 'tenant-code', value: 'vizionsys', enabled: true },
  //                 { key: 'Content-Encrypted', value: 'true', enabled: true },
  //               ],
  //               parameters: [
  //                 {
  //                   name: "secure",
  //                   description: "Whether to use encryption",
  //                   type: "boolean",
  //                   required: false
  //                 }
  //               ],
  //               requestBody: {},
  //               responses: {
  //                 success: {
  //                   status: 200,
  //                   data: {
  //                     body: {
  //                       "tenantcode": "vizionsys"
  //                     },

  //                   }
  //                 },
  //                 error: {
  //                   status: 400,
  //                   data: {
  //                     error: "Invalid request",
  //                     message: "Missing required fields"
  //                   }
  //                 }
  //               }
  //             }]
  //           },
  //         },

  //         // org login
  //         {
  //           id: "organisationLogin",
  //           label: "Authentication Login ",
  //           content: {
  //             title: "organisation  Authentication  ",
  //             description: <MarkdownComponents markdown={LoginOrganisation} />,
  //             apiendpoints: loginApiEndPoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },


  //         {
  //           id: "ticketNotifications",
  //           label: "ticketNotifications",
  //           content: {
  //             title: "ticket Notifications    ",
  //             description: <MarkdownComponents markdown={ticketNotificationsMarkdown} />,
  //             apiendpoints: ticketNotificationsapiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "Subscription",
  //           label: "Subscription ",
  //           content: {
  //             title: " subscriptionList    ",
  //             description: <MarkdownComponents markdown={subscriptionListMarkdown} />,
  //             apiendpoints: SubscriptionAapiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "getAgentByTokena",
  //           label: "getAgentByToken",
  //           content: {
  //             title: "subscriptionList",
  //             description: <MarkdownComponents markdown={agentByTokenMarkdown} />,
  //             apiendpoints: getAgentByTokenapiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "getRoleByIdMarkdown",
  //           label: "getRoleByIdMarkdown",
  //           content: {
  //             title: "getRoleByIdMarkdown",
  //             description: <MarkdownComponents markdown={getRoleByIdMarkdown} />,
  //             apiendpoints: agentroleapiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "dashboardUserGroups",
  //           label: "dashboardUserGroups",
  //           content: {
  //             title: "dashboard UserGroups ",
  //             description: <MarkdownComponents markdown={dashboardUserGroupsMarkdown} />,
  //             apiendpoints: userGroupapiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "dashboardv3",
  //           label: "dashboardv3",
  //           content: {
  //             title: "dashboardv3 ",
  //             description: <MarkdownComponents markdown={dashboardV3Markdown} />,
  //             apiendpoints: dashboardV3apiendpoints(token,tenantCode, myOrgName,baseUrl)
  //           },
  //         },
  //         {
  //           id: "groupByid",
  //           label: "groupByid",
  //           content: {
  //             title: "group byid",
  //             description: <MarkdownComponents markdown={groupGetByIdMarkdown} />,
  //             apiendpoints: groupByIdapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "groupList",
  //           label: "groupList",
  //           content: {
  //             title: "groupList ",
  //             description: <MarkdownComponents markdown={groupListMarkdown} />,
  //             apiendpoints: groupallapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "groupcreate",
  //           label: "groupCreate",
  //           content: {
  //             title: "group create ",
  //             description: <MarkdownComponents markdown={groupCreateMarkdown} />,
  //             apiendpoints: groupCreationapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "groupSoftDelete",
  //           label: "groupSoftDelete",
  //           content: {
  //             title: "groupSoftDelete",
  //             description: <MarkdownComponents markdown={groupSoftDeleteMarkdown} />,
  //             apiendpoints: groupSoftDeleteapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "groupUpdateByID",
  //           label: "groupUpdateByID",
  //           content: {
  //             title: "groupUpdateByID",
  //             description: <MarkdownComponents markdown={groupUpdateByIDMarkdown} />,
  //             apiendpoints: updateGroupByIDapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "GetRoleList",
  //           label: "Get Role List",
  //           content: {
  //             title: "Get Role List",
  //             description: <MarkdownComponents markdown={roleListMarkdown} />,
  //             apiendpoints: getRoleListapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "roleGetByIdMarkdown",
  //           label: " View Role Details by ID",
  //           content: {
  //             title: " View Role Details by ID",
  //             description: <MarkdownComponents markdown={roleGetByIdMarkdown} />,
  //             apiendpoints: getRoleByIdapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "CreateRole",
  //           label: " Create Role",
  //           content: {
  //             title: " Create Role",
  //             description: <MarkdownComponents markdown={roleCreateMarkdown} />,
  //             apiendpoints: createRoleapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "updateRole",
  //           label: " update Role",
  //           content: {
  //             title: " update Role",
  //             description: <MarkdownComponents markdown={roleUpdateMarkdown} />,
  //             apiendpoints: updateRoleapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "Roledelete",
  //           label: "Roledelete",
  //           content: {
  //             title: "Roledelete",
  //             description: <MarkdownComponents markdown={roleBulkSoftDeleteMarkdown} />,
  //             apiendpoints: deleteRolesapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "Agentget",
  //           label: "Get all Agent",
  //           content: {
  //             title: "Get all Agent",
  //             description: <MarkdownComponents markdown={agentListMarkdown} />,
  //             apiendpoints: getAllAgentapiendpoints(token, tenantCode, myOrgName)
  //           },
  //         },
  //         {
  //           id: "GetAgentById",
  //           label: "Get Agent ById",
  //           content: {
  //             title: "Get Agent ById",
  //             description: <MarkdownComponents markdown={agentGetByIdMarkdown} />,
  //             apiendpoints: getAgentByIdApiendpoints(token)
  //           },
  //         },

  //         {
  //           id: "CreateAgent",
  //           label: "Create Agent ",
  //           content: {
  //             title: "Create Agent ",
  //             description: <MarkdownComponents markdown={agentCreateMarkdown} />,
  //             apiendpoints: CreateAgentapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "updateAgent",
  //           label: "updateG Agent ",
  //           content: {
  //             title: "updateG Agent ",
  //             description: <MarkdownComponents markdown={agentUpdateMarkdown} />,
  //             apiendpoints: updateAgentapiendpoints(token)
  //           },
  //         },
  //         {
  //           id: "updateAgent",
  //           label: "Change Agent Status (Soft Delete)",
  //           content: {
  //             title: "Change Agent Status (Soft Delete) ",
  //             description: <MarkdownComponents markdown={agentStatusChangeMarkdown} />,
  //             apiendpoints: SoftDeleteapiendpoints(token)
  //           },
  //         },

  //         {
  //           id: "getCategoryList",
  //           label: "getCategory List",
  //           content: {
  //             title: "getCategory List ",
  //             description: <MarkdownComponents markdown={getCategoryListmarkdown} />,
  //             apiendpoints: getCategoryListApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "categoryById",
  //           label: " category ById ",
  //           content: {
  //             title: " category ById ",
  //             description: <MarkdownComponents markdown={categoryByIdMarkdown} />,
  //             apiendpoints: getCategoryByIdApiEndpoints(token)
  //           },
  //         },

  //         {
  //           id: "categoryupdate",
  //           label: "update category  ",
  //           content: {
  //             title: "update category  ",
  //             description: <MarkdownComponents markdown={updateCategoryMarkdown} />,
  //             apiendpoints: updateCategoryApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "categorydelete",
  //           label: "delete category  ",
  //           content: {
  //             title: "delete category  ",
  //             description: <MarkdownComponents markdown={deleteCategoryMarkdown} />,
  //             apiendpoints: deleteCategoryApiEndpoints(token)
  //           },
  //         },
  //         // Priority
  //         {
  //           id: "Priority",
  //           label: "Priority  ",
  //           content: {
  //             title: "Priority  ",
  //             description: <MarkdownComponents markdown={priorityListMarkdown} />,
  //             apiendpoints: getPriorityListApiEndpoints(token)
  //           },
  //         },

  //         {
  //           id: "createPriority",
  //           label: "Create Priority  ",
  //           content: {
  //             title: "Create Priority  ",
  //             description: <MarkdownComponents markdown={createPriorityMarkdown} />,
  //             apiendpoints: createPriorityApiEndpoints(token)
  //           },
  //         },
  //         // 
  //         {
  //           id: "Prioritybyid",
  //           label: " Priority byid ",
  //           content: {
  //             title: " Priority  byid",
  //             description: <MarkdownComponents markdown={getPriorityByIdMarkdown} />,
  //             apiendpoints: getPriorityByIdApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "updatePriority",
  //           label: " updatePriority  ",
  //           content: {
  //             title: " updatePriority  ",
  //             description: <MarkdownComponents markdown={updatePriorityMarkdown} />,

  //             apiendpoints: updatePriorityApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "deletePriority",
  //           label: " deletePriority  ",
  //           content: {
  //             title: " deletePriority  ",
  //             description: <MarkdownComponents markdown={deletePriorityMarkdown} />,

  //             apiendpoints: deletePriorityApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "WorkingTimePlan",
  //           label: " WorkingTimePlan  ",
  //           content: {
  //             title: " WorkingTimePlan  ",
  //             description: <MarkdownComponents markdown={getWorkingTimePlanMarkdown} />,

  //             apiendpoints: getWorkingTimePlanApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "WorkingTimePlanById",
  //           label: " WorkingTimePlan BY id ",
  //           content: {
  //             title: " WorkingTimePlan BYId  ",
  //             description: <MarkdownComponents markdown={getWorkingTimePlanByIdMarkdown} />,

  //             apiendpoints: getWorkingTimePlanByIdApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "WorkingTimePlanupdate",
  //           label: " WorkingTimePlanupdate ",
  //           content: {
  //             title: " WorkingTimePlan update  ",
  //             description: <MarkdownComponents markdown={updateWorkingTimePlanMarkdown} />,

  //             apiendpoints: updateWorkingTimePlanApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "WorkingTimePlancreate",
  //           label: " WorkingTimePlan create ",
  //           content: {
  //             title: " WorkingTimePlan create  ",
  //             description: <MarkdownComponents markdown={createWorkingTimePlanMarkdown} />,

  //             apiendpoints: createWorkingTimePlanApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "WorkingTimePlandelete",
  //           label: " WorkingTimePlan delete ",
  //           content: {
  //             title: " WorkingTimePlan delete  ",
  //             description: <MarkdownComponents markdown={deleteWorkingTimePlanMarkdown} />,

  //             apiendpoints: deleteWorkingTimePlanApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "TicketStatus",
  //           label: " TicketStatus  ",
  //           content: {
  //             title: " TicketStatus   ",
  //             description: <MarkdownComponents markdown={getTicketStatusListMarkdown} />,

  //             apiendpoints: getTicketStatusListApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "TicketStatuscreate",
  //           label: " TicketStatus create  ",
  //           content: {
  //             title: " TicketStatus  create ",
  //             description: <MarkdownComponents markdown={getTicketStatusListMarkdown} />,

  //             apiendpoints: getTicketStatusListApiEndpoints(token)
  //           },
  //         },
  //         {
  //           id: "getContactsMarkdown",
  //           label: "getContacts   ",
  //           content: {
  //             title: " getContacts   ",
  //             description: <MarkdownComponents markdown={getContactsMarkdown} />,

  //             apiendpoints: getContactsApiEndpoints
  //               (token)
  //           },
  //         },

  //         {
  //           id: "createContactApi",
  //           label: "createContactApi   ",
  //           content: {
  //             title: " createContactApi   ",
  //             description: <MarkdownComponents markdown={createContactMarkdown} />,

  //             apiendpoints: createContactApiEndpoints
  //               (token)
  //           },
  //         },

  //         {
  //           id: "ContactApiBYID",
  //           label: "ContactApi By id   ",
  //           content: {
  //             title: "ContactApi  byid ",
  //             description: <MarkdownComponents markdown={getContactByIdMarkdown} />,

  //             apiendpoints: getContactByIdApiEndpoints
  //               (token)
  //           },
  //         },


  //         {
  //           id: "ContactApiupdate",
  //           label: "ContactApi update   ",
  //           content: {
  //             title: "ContactApi  update ",
  //             description: <MarkdownComponents markdown={updateContactByIdMarkdown} />,

  //             apiendpoints: updateContactByIdApiEndpoints
  //               (token)
  //           },
  //         },

  //         {
  //           id: "ContactApidelete",
  //           label: "ContactApi delete   ",
  //           content: {
  //             title: "ContactApi  delete ",
  //             description: <MarkdownComponents markdown={changeContactStatusMarkdown} />,

  //             apiendpoints: changeContactStatusApiEndpoints
  //               (token)
  //           },
  //         },

  //         {
  //           id: "assetApiEndpoints",
  //           label: "assetApiEndpoints   ",
  //           content: {
  //             title: "  assetApiEndpoints ",
  //             description: <MarkdownComponents markdown={AssetsMarkdowns} />,

  //             apiendpoints: assetApiEndpoints(token, tenantCode)
  //           },
  //         },
  //         // WorkingTimePlan

  //         //   {
  //         //   id: "Ticket",
  //         //   label: "Ticket   ",
  //         //   content: {
  //         //     title: "  Ticket update ",
  //         //     description:   <MarkdownComponents markdown={ ticketMarkdowns } />,

  //         //     apiendpoints:  createOrUpdateTicketApi
  //         //     (token)
  //         //   },
  //         // },

  //       ],
  //     },
  //   ],
  // },
];

